// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartMetrics.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ChartMetrics component
 */
import React from 'react';
import DropDown from 'share/components/controls/Izenda.DropDown';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';
import { get } from 'lodash/fp';
import actions from './Izenda.ChartMetricsActions';
import PropTypes from 'prop-types';

const ChartMetrics = ({ reportPart, className, localization, onChange }) => {
  const reportPartContent = reportPart.reportPartContent || {};
  const options = reportPartContent.serieChartList;
  const classes = classnames(className, 'chart-metric-wrapper');

  return (
    options.length && (
      <span className={classes}>
        <span className="u_paddingLeftRight izenda-ChartMetrics-text">
          {localization.getText('REPORTDESIGNER_LABEL_METRICS')}
        </span>
        <DropDown
          options={options}
          onChange={onChange}
          value={get('fieldName', reportPartContent.activeSerie)}
          blankOption
          blankOptionText={localization.getText('COMMON_LABEL_ALL')}
          valueField="fieldName"
          labelField="fieldName"
          renderInContainer={false}
          maxHeight={120}
        />
      </span>
    )
  );
};

ChartMetrics.propTypes = {
  reportPart: PropTypes.object,
  className: PropTypes.string,
  onChange: PropTypes.func
};

export default connect(actions)(ChartMetrics);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ChartMetrics.js